import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import '../scss/404.scss';
import { WEB_URL } from '../api/URLs';
import { H1 } from '../components/headings';
import { donationActions } from '../store/actions';
import { useNonInitialEffect } from '../hooks/UseNonInitialEffect';
import { Header, Footer, P, MixPanelTrackedLink } from '../components';

export function TransactionFailed() {
    const dispatch = useDispatch();
    const { donationId } = useParams();
    const [responseMessage, setResponseMessage] = useState(null);
    const donationDetails = useSelector(state => state.updateDonationDetails.donation_details);

    useEffect(() => {
        dispatch(donationActions.updateLoaderState(true));
        dispatch(donationActions.getDonationDetails(donationId));
    }, [])

    useNonInitialEffect(() => {

        if (donationDetails?.data?.payment_gateway_response_message)
            setResponseMessage(donationDetails.data.payment_gateway_response_message)

    }, [donationDetails])

    return <React.Fragment>
        <Header />
        <main className="data-not-avaibale App-content">
            <div className="container" style={{ minHeight: '525px' }}>
                {donationDetails?.data && <div className="center-box">
                    <H1 content={"Transaction Failed"} />
                    <P><i style={{ fontSize: "medium" }}>"{responseMessage}"</i></P>
                    <MixPanelTrackedLink
                        type="button"
                        label="Try again"
                        context={`Transaction failed screen for donation id ${donationDetails?.data.donation_id}`}
                        variant="contained"
                        size="small"
                        sx={{ float: 'right', marginTop: '10px' }}
                        href={WEB_URL.FUNDRAISER_CHECKOUT(donationDetails?.data.event_id)}>Try again</MixPanelTrackedLink>
                    {/* <div className="bg-picture img-fluid" style={{ backgroundImage: `url('${require('../assets/images/404-small.jpg')}')` }} alt="" ></div> */}
                </div>}
            </div>
        </main>
        <Footer />
    </React.Fragment>
}

